module.exports = __webpack_public_path__ + "static/background-desktop-4327ff93f433257be1c35cf3bd8c7769.png";